export default function IdentityIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='3' y='3' width='18' height='18' rx='2' stroke='currentColor' strokeWidth='1.5' />
      <path d='M8 16V12' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
      <path d='M12 16V10' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
      <path d='M16 16V8' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
}
